<div class="skill">
  <div class="icon-user">
    <img src="assets/img/circle-user.svg" alt="user" class="disabled" *ngIf="data.average.self.last_saved.value === null">
    <img src="assets/img/circle-user-active.svg" (click)="openDevReport()" alt="user" *ngIf="data.average.self.last_saved.value !== null">
  </div>
  <div class="icon-plus">
    <img *ngIf="!data.completed.self || data.type === 'l' || !data.active.manager" src="assets/img/plus.svg" alt="plus" class="disabled">
    <img *ngIf="data.completed.self && data.type === 'lm' && data.active.manager" src="assets/img/plus-active.svg" alt="plus" (click)="onEdit()">
  </div>

  <div class="title">{{data.delegate.full_name}}</div>

  <div class="line">
    <div class="el">
      {{"__SC_TEAM_LEARNER__" | translate}} <div class="my-color-red">{{ data.average.self.last_saved.output.long }}</div>
    </div>
    <div class="el">
      {{"__SC_TEAM_STATUS__" | translate}}  <div class="{{ data.completed.self ? 'my-color-green' : 'my-color-red'}}">{{ data.completed.self ? 'Complete' : 'Incompleted'}}</div>
    </div>
  </div>

  <div class="group">
    <div class="el">
      {{"__SC_TEAM_SELF__" | translate}}
      <span class="active" [ngClass]="data.average.self.average.output.style.class">
        {{data.average.self.average.output.value}}</span>
    </div>
    <div class="el">
      {{"__SC_TEAM_MANAGER__" | translate}}
      <span class="active" *ngIf="data.type === 'lm'" [ngClass]="data.average.manager.average.output.style.class">
        {{data.average.manager.average.output.value}}</span>
      <span *ngIf="data.type === 'l'" class="active my-background-grey-white">-</span>
    </div>
    <div class="el">
      {{"__SC_TEAM_DESIRED__" | translate}}
      <span class="active" *ngIf="data.type === 'lm'" [ngClass]="data.average.desired.average.output.style.class">
        {{data.average.desired.average.output.value}}</span>
      <span *ngIf="data.type === 'l'" class="active my-background-grey-white">-</span>
    </div>
    <div class="el">
      {{"__SC_TEAM_GAP__" | translate}}
      <span class="active" *ngIf="data.type === 'lm'" [ngClass]="data.average.gap.average.output.style.class">
        {{data.average.gap.average.output.value}}</span>
      <span *ngIf="data.type === 'l'" class="active my-background-grey-white">-</span>
    </div>
    <div class="el">
      {{"__SC_TEAM_AGREED__" | translate}}
      <span class="active" *ngIf="data.type === 'lm'" [ngClass]="data.average.agreed.average.output.style.class">
        {{data.average.agreed.average.output.value}}</span>
      <span *ngIf="data.type === 'l'" class="active my-background-grey-white">-</span>
    </div>
  </div>
</div>
